/* eslint-disable @typescript-eslint/explicit-function-return-type */
import styled, { css } from 'styled-components';
import { typography } from '@everlywell/leaves';

import { ariesTheme } from 'styles/ariesTheme';

const mobileFriendlyHover = styles => css`
  @media (hover: hover) {
    &:hover {
      ${styles};
    }
  }
  &:active {
    ${styles};
  }
`;

export const baseButtonStyles = css`
  display: inline-block;
  width: 100%;
  box-sizing: border-box;
  user-select: none;
  cursor: pointer;
  font-size: 18.7px;
  font-weight: ${typography.weight.bold};
  margin-bottom: 0;
  line-height: 1.5;
  text-align: center;
  min-height: 3rem;
  padding: 10px;
  text-decoration: none;

  a {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    text-decoration: inherit;
    color: inherit;
  }
`;

const primaryHoverStyles = css`
  background-color: rgb(
    ${props =>
      props.theme.primaryHoverBgColor || ariesTheme.primaryHoverBgColor}
  );
`;

const PrimaryStyles = css`
  ${baseButtonStyles};
  background-color: rgb(
    ${props => props.theme.primaryBgColor || ariesTheme.primaryBgColor}
  );
  color: rgb(${props => props.theme.primaryColor || ariesTheme.primaryColor});
  ${mobileFriendlyHover(primaryHoverStyles)};

  &:focus {
    ${primaryHoverStyles};
  }

  &:active {
    ${primaryHoverStyles};
  }

  &[disabled] {
    background-color: rgb(
      ${props => props.theme.disabledBgColor || ariesTheme.disabledBgColor}
    );

    &:hover {
      cursor: default;
    }
  }
`;

const secondaryHoverStyles = css`
  border: 2px solid
    rgb(
      ${props =>
        props.theme.secondaryHoverBorderColor ||
        ariesTheme.secondaryHoverBorderColor}
    );
  color: rgb(
    ${props =>
      props.theme.secondaryHoverColor || ariesTheme.secondaryHoverColor}
  );
`;

const SecondaryStyles = css`
  ${baseButtonStyles};
  background-color: rgb(
    ${props => props.theme.secondaryBgColor || ariesTheme.secondaryBgColor}
  );
  border: 2px solid
    rgb(
      ${props =>
        props.theme.secondaryBorderColor || ariesTheme.secondaryBorderColor}
    );
  color: rgb(
    ${props => props.theme.secondaryColor || ariesTheme.secondaryColor}
  );
  ${mobileFriendlyHover(secondaryHoverStyles)};
  &:active {
    ${secondaryHoverStyles};
  }

  &:focus {
    ${secondaryHoverStyles};
  }

  &[disabled] {
    border-color: rgb(
      ${props => props.theme.disabledBgColor || ariesTheme.disabledBgColor}
    );
    background-color: rgb(
      ${props =>
        props.theme.disabledSecondaryBgColor ||
        ariesTheme.disabledSecondaryBgColor}
    );
    color: rgb(
      ${props => props.theme.disabledBgColor || ariesTheme.disabledBgColor}
    );

    &:hover {
      cursor: default;
    }
  }
`;

const ComponentWrapper = styled.div`
  ${props => (props.secondary ? SecondaryStyles : PrimaryStyles)};

  &:focus-within {
    ${props => (props.secondary ? secondaryHoverStyles : primaryHoverStyles)};
  }
`;

const A = styled.a`
  ${props => (props.secondary ? SecondaryStyles : PrimaryStyles)};
`;

const Button = styled.button`
  ${props => (props.secondary ? SecondaryStyles : PrimaryStyles)};
`;

export { A, Button, ComponentWrapper, PrimaryStyles, SecondaryStyles };
